import React from "react";
import PropTypes from "prop-types";
import {Line, SeparatorWrapper} from "./styles";

const Separator = props => {
    const {icon} = props;

    return (<SeparatorWrapper>
        <Line />
        <img src={icon} alt="separator" />
        <Line />
    </SeparatorWrapper>)
}

Separator.propTypes = {
    icon: PropTypes.string
}

export default Separator;
